import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import '../styles/SwiperCustomPagination.css';
import { useDispatch, useSelector } from 'react-redux';
import { setUserData } from '../../store/userSlice';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import ListenVoice from '../../components/ui/ListenVoice';
import { GiftListProfile } from '../../components/gifts/GiftListProfile';
import DotSpinner from '../../components/shared/DotSpinner';

function ProfileEdit() {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.userData);
  const { userId } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const swiperRef = useRef(null);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!userId) return;
      try {
        const response = await axiosPrivate.get(`/users/${userId}`);
        console.log(response.data);
        dispatch(setUserData(response.data));
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [dispatch, userId]);

  // Обновляем данные при возврате на страницу (когда фокус возвращается)
  useEffect(() => {
    const handleFocus = async () => {
      if (!userId) return;
      try {
        const response = await axiosPrivate.get(`/users/${userId}`);
        dispatch(setUserData(response.data));
      } catch (error) {
        console.error('Error refreshing user data:', error);
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [dispatch, userId, axiosPrivate]);

  // Функция для вычисления возраста
  const calculateAge = (birthDate) => {
    if (!birthDate) return '';
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }

    return age;
  };

  // Функция для отображения цели знакомства
  const getPurposeText = (purpose) => {
    switch (purpose) {
      case 'Флирт и свидания':
        return 'Флирт и свидания';
      case 'Серьёзные отношения':
        return 'Серьёзные отношения';
      case 'Дружеское общение':
        return 'Дружеское общение';
      case 'Обо всём и ни о чём':
        return 'Обо всём и ни о чём';
      default:
        return 'Не указано';
    }
  };

  // Функции для переключения фотографий
  const handlePrevPhoto = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNextPhoto = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center w-full mt-[200px] text-white">
        <DotSpinner />
      </div>
    );
  }

  return (
    <div>
      <div className="relative h-[100%]">
        <div className="w-[100%] pt-[32px]  flex flex-col !items-center">
          <div className="z-0 w-full flex justify-center items-center flex-col">
            <div className="w-full px-4 flex flex-row ">
              <img
                src="/icons/Button-back.svg"
                alt="Назад"
                onClick={() => {
                  navigate(-1);
                }}
                className=" w-[44px] h-[44px]"
              />
            </div>
            <div className="w-[100%] flex justify-center align-center mt-4 px-4">
              <div className="relative w-full rounded-[16px]">
                <div className="w-full relative">
                  <div
                    className="custom-pagination"
                    style={{
                      position: 'absolute',
                      top: '0px',
                      zIndex: 10,
                      left: '0',
                      right: '0',
                      width: '100%',
                    }}
                  ></div>
                </div>
                <Swiper
                  modules={[Pagination]}
                  spaceBetween={0}
                  slidesPerView={1}
                  className="h-[560px]"
                  pagination={{
                    el: '.custom-pagination',
                  }}
                  onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                  }}
                >
                  {userData.photos.map(
                    (photo, index) =>
                      photo && (
                        <SwiperSlide key={index} className="relative">
                          <img
                            src={photo}
                            alt={`Фотография ${index + 1}`}
                            className="z-[1] w-full h-[544px] rounded-[16px] object-cover"
                          />

                          <div
                            className="absolute top-0 left-0 w-[40%] h-full z-[5] cursor-pointer"
                            onClick={handlePrevPhoto}
                          />

                          <div
                            className="absolute top-0 right-0 w-[40%] h-full z-[5] cursor-pointer"
                            onClick={handleNextPhoto}
                          />
                        </SwiperSlide>
                      ),
                  )}
                </Swiper>

                <img
                  src="/icons/redactirovat_photo.svg"
                  alt="Редактировать фото"
                  className="absolute z-[10] left-[30px] top-[500px]"
                  onClick={() => navigate(config.ROUTES.PROFILE.PHOTO)}
                />
                <div className="shadow-[0_-25px_30px_rgba(0,0,0,0.9)] rounded-[16px] rounded-t-none relative z-[5] flex flex-col pl-[24px] pr-[24px] pb-[24px] bg-[#010D0D] translate-y-[-27px] drop-shadow-[0_0_30px_0_rgb(0,0,0)]">
                  <div className="flex justify-between items-start mt-6">
                    <h1 className="font-raleway font-bold text-white text-[26px] pr-12 truncate flex-1">
                      {userData.name}, {calculateAge(userData.birthDay)} лет
                    </h1>
                    <img
                      src="/icons/izmenit.svg"
                      alt="Изменить"
                      className="flex-shrink-0 cursor-pointer mt-1"
                      onClick={() => navigate(config.ROUTES.PROFILE.MAIN)}
                    />
                  </div>
                  <div className="flex justify-between items-center mt-2">
                    <h1 className="font-raleway font-light text-white text-[18px] pr-12 truncate">
                      {userData.city}, {userData.country}
                    </h1>
                    <img
                      src="/icons/izmenit.svg"
                      alt="Изменить"
                      className="flex-shrink-0 cursor-pointer"
                      onClick={() => navigate(config.ROUTES.PROFILE.MAIN)}
                    />
                  </div>
                  <div className="border-b-2 border-white/30 pt-5" />
                  <div className="flex justify-between items-start mt-6">
                    <div className="flex-1 pr-12">
                      <h1 className="font-raleway font-bold text-white text-[18px]">Цель знакомства</h1>
                      <h1 className="font-raleway font-light text-white text-[18px] text-wrap mt-2">
                        {getPurposeText(userData.purpose)}
                      </h1>
                    </div>
                    <img
                      src="/icons/izmenit.svg"
                      alt="Изменить"
                      className="flex-shrink cursor-pointer mt-10"
                      onClick={() => navigate(config.ROUTES.PROFILE.MEET_GOAL)}
                    />
                  </div>
                  <div className="flex justify-between items-center mt-6">
                    <h1 className="font-raleway font-bold text-white text-[18px]">Аудио визитка</h1>
                    <img
                      src="/icons/izmenit.svg"
                      alt="Изменить"
                      className="flex-shrink-0 cursor-pointer"
                      onClick={() => navigate(config.ROUTES.PROFILE.AUDIO)}
                    />
                  </div>
                  <div className="mt-2">
                    {userData?.audioMessage?.file ? (
                      <ListenVoice
                        preSignedAudio={userData.audioMessage.file}
                        bars={userData.audioMessage.bars || []}
                      />
                    ) : (
                      <div className="w-full h-[64px] bg-[#FFFFFF1A] rounded-[8px] flex items-center justify-center">
                        <span className="text-white opacity-50">Аудио не загружено</span>
                      </div>
                    )}
                  </div>
                  <div className="flex justify-between items-start mt-6">
                    <div className="flex-1 pr-12">
                      <h1 className="font-raleway font-bold text-white text-[18px]">Интересы</h1>
                      <h1 className="font-raleway font-light mt-2 text-white text-[18px] break-words">
                        {userData.interests.join(', ')}
                      </h1>
                    </div>
                    <img
                      src="/icons/izmenit.svg"
                      alt="Изменить"
                      className="flex-shrink-0 cursor-pointer"
                      onClick={() => navigate(config.ROUTES.PROFILE.INTERESTS)}
                    />
                  </div>
                  <GiftListProfile userId={userId} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileEdit;
